import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { BarI18nPipe } from '@lvflanders/bar-ng-ui';

@Component({
    templateUrl: './dido-bestandsnaam-renderer.html',
    imports: [MatIcon, MatTooltip, BarI18nPipe]
})
/** Will render a bestandsnaam with an icon in an ag-grid cell. */
export class DidoBestandsnaamRenderer implements ICellRendererAngularComp {
    params: ICellRendererParams;

    refresh(params: any): boolean {
        return false;
    }
    agInit(params: ICellRendererParams): void {
        this.params = params;
    }

    get bestandsnaam(): string {
        return this.params.data['bestandsnaam'];
    }

    get bestandsextensie(): string {
        return this.params.data['bestandsextensie'];
    }

    get fontIcon(): string {
        return this.params.data['fontIcon'];
    }

    get hidden(): boolean {
        return this.params.data['isReadContentAllowed'] && this.params.data['status'] != 'Versnipperd' && this.params.data['status'] != 'Vernietigd'
            ? false
            : true;
    }

    action(): boolean {
        return (<any>this.params).action(this.params.data);
    }
}
